import {Component} from 'substance'
import './scss/bar-item.scss'

/**
 * A topbar rendered icon, text or image.
 * Either a title or icon can be used as item rendered in the top bar.
 * 
 * @typedef Component.BarItemComponent.Props
 * @property {string} title - Text title of text bar item
 * @property {string} icon - Can be either an FontAwesome icon or image url
 * @property {string} css - Custom css string to apply to bar item
 * @property {boolean} enabled - Whether it is enabled or not
 * @property {boolean} active - Whether it is active, selected, or not
 *
 * @param {Component.BarItemComponent.Props} props
 * @property {Component.BarItemComponent.Props} props
 *
 * @memberof Component
 */
class BarItemComponent extends Component {

    constructor(...args) {
        super(...args)
    }

    getInitialState() {
        return {
            active: false
        }
    }

    render($$) {
        let el = null

        if (this.props.title) {
            el = $$('div')
                .addClass('sc-np-bar-item')
                .append(
                    $$('a')
                        .addClass('text')
                        .append(this.props.title)
                )
        }
        else if (this.props.icon.substring(0, 3) === 'fa-') {
            el = $$('div')
                .addClass('sc-np-bar-item')
                .append(
                    $$('a')
                        .addClass('fa ' + this.props.icon)
                )

        }
        else {
            let css = this.props.css || {}
            css['background-image'] = 'url("' + this.props.icon + '")'

            el = $$('div')
                .addClass('sc-np-bar-item')
                .append(
                    $$('a')
                        .addClass('img')
                        .css(css)
                )
        }

        if (this.props.active) {
            el.addClass('active')
        }

        if (this.props.enabled === false) {
            el.addClass('disabled')
        }

        return el
    }
}

export {BarItemComponent}
